module.exports =  {

  whatIsOrdersForMe: {
    title: 'What Is "Orders for Me"?',
    contents: `
      <p>When an order is being created, the maker of the order can specify a taker
      address so that the order can only be filled by that account. This feature is
      useful for private trading between two traders.</p>
      <p>After such an order is created, the order will appear on the "Orders for Me"
      page under the taker's account.
      </p>
    `,
  },

}
